import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class UserService {

  // http options used for making API calls
  private httpOptions: any;

  // the actual JWT token
  public token: string;

  // the token expiration date
  public token_expires: Date;

  // the username of the logged in user
  public username: string;
  public email: string;
  public apiurl:string;

  // error messages received from the login attempt
  public errors: any = [];
  private loggedout:boolean= true;

  constructor(private http: HttpClient,private router: Router) {   
    this.apiurl=environment.pythonUrl;
    this.httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
  }


//http://ix.intuceo.com:5500/api-token-auth/  http://127.0.0.1:8000/api-token-auth/

  // Uses http.post() to get an auth token from djangorestframework-jwt endpoint
  public login(user) {   
    console.log(this.apiurl);
    this.http.post(this.apiurl+'/api-token-auth/', JSON.stringify(user), this.httpOptions).subscribe(
      data => { 
        this.loggedout=false;             
        this.updateData(data['token']);                                  
          this.gotoSearch();  
          this.refreshToken();                 
      },
      err => {
        console.error('login error', err);
        this.errors = err['error'];
      }
    );
  }

  public register(user) {   
    this.http.post(this.apiurl+'/api-token-auth/', JSON.stringify(user), this.httpOptions).subscribe(
      data => {             
        //this.updateData(data['token']);                                  
          this.gotoSearch();                   
      },
      err => {
        console.error('login error', err);
        this.errors = err['error'];
      }
    );
  }

  gotoSearch(){   
    sessionStorage.setItem('loggedin','true'); 
    sessionStorage.setItem('loggedinname',this.username);  
    this.router.navigate(['/search'],{ state:{ logged_in_user: this.username}});  // define your component where you want to go
}

  /**
   * Refreshes the JWT token, to extend the time the user is logged in
   */
  public refreshToken() {
    if(this.loggedout==true){

    }
    else{

    setTimeout(()=>{ 
      
     

    var tokens="JWT " + sessionStorage.getItem('token');

      this.httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens})
      };

    this.http.post(this.apiurl+'/api-token-refresh/', JSON.stringify({token: this.token}), this.httpOptions).subscribe(
      data => {
        console.log('refresh success', data);        
        console.log('refresh success', data['token']);        
        this.updateData(data['token']);
        sessionStorage.setItem('token',this.token);
        this.refreshToken();
      },
      err => {
        console.error('refresh error', err);
        this.errors = err['error'];
      }
    );
  }, 1680000)
}

  }

  public logout() {
    this.loggedout=true;
    this.token = null;
    this.token_expires = null;
    this.username = null;
    sessionStorage.setItem('loggedin','false'); 
    this.gotoLogin();
  }

  gotoLogin(){    
    this.router.navigate(['/login']);  // define your component where you want to go
}
  private updateData(token) {
    this.token = token;
    this.errors = [];

    // decode the token to read the username and expiration timestamp
    const token_parts = this.token.split(/\./);
    const token_decoded = JSON.parse(window.atob(token_parts[1]));
    this.token_expires = new Date(token_decoded.exp * 1000);    
    this.username = token_decoded.username;
    this.email = token_decoded.email; 
    sessionStorage.setItem('token',this.token);
    
  }
}
